import React from "react";
import Image from "next/image";
import Link from "next/link";
import { Icon } from "@iconify/react";
import CardButton from "@/components/ui/CardButton";

// Define the package item type
type PackageItem = {
  banner: string;
  name: string;
  overview: string;
  duration: string | number;
  subheading: string;
  slug: string;
};

type PackageCardProps = {
  item: PackageItem;
  className?: string;
  onViewMore?: () => void;
  onEnquiry?: () => void;
  viewMoreLink?: string;
  enquiryLink?: string;
};

const PackageCard = ({ item }: PackageCardProps) => {
  return (
    <div className="group cursor-pointer w-full  flex flex-col justify-start items-start gap-3 border rounded-md shadow-sm">
      {/* Image */}
      <Link href={`/package_detail/${item.slug}`} className="w-full">
        <figure className="rounded-t-md relative w-full h-52 md:h-[15rem] overflow-hidden">
          <div className="absolute inset-0 z-[80] flex items-end">
            <div className="p-3 text-sm font-medium">
              <div className="flex bg-secondary-500 px-3 py-1 rounded-xl text-white gap-2 items-center">
                <span>{item.duration} Days</span>
              </div>
            </div>
          </div>
          <Image
            width={1000}
            height={1000}
            src={item?.banner || "/bannerImg.jpeg"}
            alt="banner-image"
            quality={90}
            className="w-full h-full object-cover object-bottom group-hover:scale-105 ease-in-out duration-300"
          />
        </figure>
      </Link>

      <div className="flex p-2 flex-col gap-2 justify-between h-full">
        {/* Description */}
        <div className="flex w-full flex-col gap-2">
          <span className="text-md line-clamp-1 text-xl lg:text-2xl font-semibold  ">
            {item.name}
          </span>
          <p className="text-sm  line-clamp-2  font-medium text-secondary-400 ">
            {item.subheading}
          </p>
          {/* <p
            className="ql-editor text-lg" // Add this class!
            dangerouslySetInnerHTML={{ __html: item.overview.slice(0, 60).replace(/<[^>]+>/g, "") + "..." }}
          ></p> */}
        </div>

        {/* Buttons */}
        <div className="grid grid-cols-2 gap-2 w-full mt-2">
          <Link
            href={`/package_detail/${item.slug}`}
            className="group-hover:bg-white rounded-md group-hover:border-primary2 border"
          >
            <CardButton className="!w-full !bg-transparent !text-black !shadow-none">
              View More
            </CardButton>
          </Link>

          <Link href={`/package_detail/${item.slug}#date-&-price`}>
            <CardButton style={{
              backgroundColor: "#E55E25"
            }} className="!w-full">View Dates</CardButton>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PackageCard;
